import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cdefe264"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__nav" }
const _hoisted_3 = { class: "header__nav-list" }
const _hoisted_4 = { class: "header__nav-item" }
const _hoisted_5 = { class: "header__nav-item" }
const _hoisted_6 = { class: "header__nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("button", {
      class: "header__logo",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'feedsPage' })))
    }, [
      _createVNode(_component_Icon, { name: "Logo" })
    ]),
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("button", {
            class: "header__btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'feedsPage' })))
          }, [
            _createVNode(_component_Icon, { name: "Home" })
          ])
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createElementVNode("button", {
            class: "header__btn header__btn--avatar",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'repositories' })))
          }, [
            _createVNode(_component_Avatar, { avatarUrl: $props.avatarUrl }, null, 8, ["avatarUrl"])
          ])
        ]),
        _createElementVNode("li", _hoisted_6, [
          _createElementVNode("button", {
            class: "header__btn",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.logoutUser && _ctx.logoutUser(...args)))
          }, [
            _createVNode(_component_Icon, { name: "Exit" })
          ])
        ])
      ])
    ])
  ]))
}